export default [
  {
    path: '/BC/:landlordNo/fy',
    name: 'BCFY',
    meta: "品牌定制房源",
    component: ()=> System.import("@/PagesAreaBrandCustom/houseList/")
  },
  {
    path: '/BC/:landlordNo/bx',
    name: 'BCBX',
    meta: "", //品牌定制保修
    component: ()=> System.import("@/PagesAreaBrandCustom/repair")
  },
  {
    path: '/BC/:landlordNo/jz',
    name: 'BCJZ',
    meta: "", //品牌定制交租
    component: ()=> System.import("@/PagesAreaBrandCustom/orderList")
  },
  {
    path: '/BC/:landlordNo/emptyInvalid',
    name: 'BCEmptyInvalid',
    meta: "品牌定制失效页",
    component: ()=> System.import("@/PagesAreaBrandCustom/emptyInvalid")
  },
  // 官网、银联房间详情
  {
    path: '/BC/:landlordNo/houseDetail/:id',
    name: 'BChouseDetail',
    meta: {
      titleBackup: '品牌定制房间详情页'
    },
    component: () => System.import("@/PagesAreaBrandCustom/houseDetail")
  },
  // 我
  {
    path: '/BC/:landlordNo/my',
    name: 'BCMy',
    meta: {
      titleBackup: '品牌定制我的'
    },
    component: () => System.import("@/PagesAreaBrandCustom/my")
  }
]



// WEBPACK FOOTER //
// ./src/router/brandCustom.js